import { z } from "zod";

export const domainList = ["Team"] as const;

export const domainSchema = z.enum(domainList);

export type Domain = z.infer<typeof domainSchema>;
